import Proptypes from 'prop-types';
import React, { useRef, useEffect, useState } from 'react'

import { useEditor, EditorContent } from '@tiptap/react'

import Toolbar from './components/Toolbar';
import extensions from './extensions'

import '../../../assets/no-tailwind.css';

const propTypes = {
  content: Proptypes.string,
  onChange: Proptypes.func,
};

export default function Tiptap({ content, onChange, height, small = false }) {
  const viewRef = useRef(null);
  const [width, setWidth] = useState(() => typeof window !== 'undefined' ? window.innerWidth : 0)

  useEffect(() => {
    const updateWidth = () => {
      setWidth(window.innerWidth)
    };

    updateWidth()

    window.addEventListener('resize', updateWidth)

    return () => {
      window.removeEventListener('resize', updateWidth)
    };
  }, [])

  const handleChange = ({ editor }) => {
    const html = editor.getHTML()
    onChange(html)
  }

  const editor = useEditor({ extensions, content, onUpdate: handleChange })

  return <>
    <Toolbar editor={editor} small={small || width <= 800} />
    <div className={`twy-border-base border border-t-0 p-2 overflow-y-auto ${height && `h-[${height}]`}`}>
      <div ref={viewRef} className='no-tailwind'>
        <EditorContent editor={editor} />
      </div>
    </div>
  </>
}

Tiptap.propTypes = propTypes
Tiptap.defaultProps = {}
